import React from 'react';
import { BreadcrumbItem } from '../types';

interface BreadcrumbNavigationProps {
  breadcrumbs: BreadcrumbItem[];
  onNavigate: (folderId: string | null) => void;
}

/** Drive / Documents / Contracts / 2026 -- every segment but the last one is a link back to that folder. */
export function BreadcrumbNavigation({ breadcrumbs, onNavigate }: BreadcrumbNavigationProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-sm">
      {breadcrumbs.map((crumb, index) => {
        const last = index === breadcrumbs.length - 1;
        return (
          <React.Fragment key={crumb.id}>
            {index > 0 && <span className="text-gray-400">/</span>}
            {last ? (
              <span className="px-1 py-0.5 font-medium text-gray-900" aria-current="page">{crumb.name}</span>
            ) : (
              <button type="button" onClick={() => onNavigate(crumb.folderId)} className="px-1 py-0.5 rounded text-blue-600 hover:text-blue-800 hover:underline">
                {crumb.name}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
